import { render, staticRenderFns } from "./DataTypesEdit.vue?vue&type=template&id=21386b57&scoped=true"
import script from "./DataTypesEdit.vue?vue&type=script&lang=js"
export * from "./DataTypesEdit.vue?vue&type=script&lang=js"
import style0 from "./DataTypesEdit.vue?vue&type=style&index=0&id=21386b57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21386b57",
  null
  
)

export default component.exports